import { useEffect, useMemo, useState } from 'react';
import styles from './producersComponent.module.scss';
import producersController from '../../../../../Api/producersController';
import ListPartWithEditForm from './Components/ListPart/ListPartWithEditForm';
import CsvDownloadButton from 'react-json-to-csv';
import { useUser } from '../../../../../hooks/useUser';

export default function ProducersComponent() {
    const user = useUser();
    const [showAddForm, setShowAddForm] = useState(false);
    const [producersData, setProducers] = useState([]);
    const [query, setQuery] = useState('');
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const [name, setName] = useState('');
    const [link, setLink] = useState('');
    const [image, setImage] = useState('');

    const loadProducers = async () => {
        setLoading(true);
        setError('');
        try {
            const res = await producersController.getAllProducers();
            setProducers(res.producers || []);
        } catch {
            setError('Nie udało się pobrać producentów.');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => { loadProducers(); }, []);

    const filteredProducers = useMemo(() => {
        const phrase = query.trim().toLocaleLowerCase('pl');
        if (!phrase) return producersData;
        return producersData.filter((producer) => `${producer.name || ''} ${producer.link || ''}`.toLocaleLowerCase('pl').includes(phrase));
    }, [producersData, query]);

    const addProducer = async () => {
        if (!name.trim() || !image) {
            setError('Podaj nazwę i wybierz logo producenta.');
            return;
        }
        setError('');
        try {
            const res = await producersController.addProducer({ name: name.trim(), logo: image, link: link.trim() });
            if (res.newProducer) setProducers((current) => [...current, res.newProducer]);
            setName(''); setLink(''); setImage(''); setShowAddForm(false);
        } catch {
            setError('Nie udało się dodać producenta.');
        }
    };

    const deleteProducer = async (_id) => {
        if (!window.confirm('Usunąć tego producenta?')) return;
        await producersController.deleteProducer(_id);
        setProducers((current) => current.filter((producer) => producer._id !== _id));
    };

    const editProducer = async (producer) => {
        const res = await producersController.editProducer(producer);
        setProducers((current) => current.map((item) => item._id === producer._id ? (res.editedProducer || item) : item));
    };

    const exportData = producersData.map(({ __v, ...producer }) => producer);

    return <div className={styles.general}>
        <div className={styles.moduleHeader}>
            <div><h2>Producenci</h2><p>Zarządzaj markami, ich logotypami i linkami.</p></div>
            <span className={styles.counter}>{producersData.length} producentów</span>
        </div>

        <div className={styles.toolbar}>
            <input aria-label="Szukaj producenta" placeholder="Szukaj po nazwie lub adresie…" value={query} onChange={(event) => setQuery(event.target.value)} />
            <div className={styles.actions}>
                <CsvDownloadButton data={exportData} filename="producenci.csv">Eksportuj CSV</CsvDownloadButton>
                <button type="button" onClick={loadProducers}>Odśwież</button>
                {user.hasPermission('producers.create') && <button type="button" className={styles.primaryButton} onClick={() => setShowAddForm((current) => !current)}>{showAddForm ? 'Anuluj' : 'Dodaj producenta'}</button>}
            </div>
        </div>

        {error && <div className={styles.error}>{error}</div>}
        {showAddForm && <div className={styles.formContainer}>
            <label>Nazwa producenta<input type="text" value={name} onChange={(event) => setName(event.target.value)} /></label>
            <label>Adres strony<input type="url" value={link} onChange={(event) => setLink(event.target.value)} placeholder="https://…" /></label>
            <label>Logo<input type="file" accept="image/*" onChange={(event) => setImage(event.target.files?.[0] || '')} /></label>
            <button type="button" className={styles.primaryButton} onClick={addProducer}>Zapisz producenta</button>
        </div>}

        <div className={styles.listHeader}><span>Logo</span><span>Producent</span><span>Adres strony</span><span>Akcje</span></div>
        {loading ? <div className={styles.state}>Pobieranie producentów…</div> : filteredProducers.length === 0 ? <div className={styles.state}>Brak producentów pasujących do wyszukiwania.</div> : <div className={styles.producersData}>
            {filteredProducers.map((producer) => <ListPartWithEditForm key={producer._id} {...producer} image={`${producer.logo || ''}`} onDelete={deleteProducer} onEdit={editProducer} canEdit={user.hasPermission('producers.update')} canDelete={user.hasPermission('producers.delete')} />)}
        </div>}
    </div>;
}
